import React from 'react';
import { apiGet, apiPost } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { isNullOrUndefined, isEmpty } from '../../../store/storeFunctions';
import { popupActions } from '../../../store/popupStore';
import { REGISTRY, registrySearchActions, SEARCH_TYPE } from '../../../store/ceeSearchStore';
import { Translate, withLocalize } from 'react-localize-redux';
import CeeReportDateInformation from './ceeReportDateInformation';
import CeeSearchCriteria from './ceeSearchCriteria';
import ExcelExportButton from '../../common/excelExportButton';
import SvgRefresh from "../../../img/icons/Refresh";

import './cee.scss';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';

class RpveDetail extends React.Component {
    state = {
        country: "SK"
    }

    
    componentDidMount() {
         this.getData();
    }
      
    onError = (data) => this.setState({ isLoading: false, responseData: data });

    getData = () => {
        this.setState({ isLoading: true });
        this.props.setResultsRequestParams('rpve', null);

        apiGet(this.getBaseUrl(this.props.requestId),
           null,
            (data) => {
                if (isNullOrUndefined(data.error) && !isNullOrUndefined(data.data)) {
                     this.props.setResultsRequestParams('rpve', { subPath: 'results', id: this.props.requestId, params: { country: 'sk' } });
                     this.onGetDataSuccess(data.data);
                }
                else {
                    this.setState({ errors: { exception: data.error.message } });
                    this.onError();
                }
            },
            () => this.onError()
        );
    }

    onSuccess = (data) => {
        let searchType = null;
        switch (data.header.type) {
            case "Person": searchType = SEARCH_TYPE.fo; break;
            case "Company": searchType = SEARCH_TYPE.po; break;
            case "Cause": searchType = SEARCH_TYPE.trialFile; break;
            default: searchType = null; break;
        }
        this.setState({ isLoading: false, data: data, searchType: searchType });
    }

    
    onGetDataSuccess = (data) => {
        if (!data.isCustomerResult) {
            apiPost(this.getBaseUrl(data.header.id) + '/mark-as-seen', null, null,
                () => this.onSuccess(data),
                () => this.onError()
            );
        } else {
            this.onSuccess(data)
        }
    }


    render() {
        let index = 0;

        if (this.state.isLoading)
            return <Circles />

            return (
                <div className="cee-detail">
                    {/* {this.renderErrors()} */}
                    {this.state.data && <>
                        <div style={{ paddingTop: "1em" }}></div>
                        <div className='report-section' style={{ border: "none" }}>
                            <div className='header-wrap' style={{ marginLeft: "0", border: "none", cursor: "default" }}>
                                <div className="header-body" >
                                    <div className="name">{this.props.translate("Search.Cee.SearchParameters")}</div>
                                </div>
                            </div>
                            <div className='report-section-body' style={{ border: "none", marginLeft: 0 }}>
                                <div>
                                    <CeeSearchCriteria country={this.state.country} data={this.state.data} registry={REGISTRY.rpve} />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="aml-available">
                                        {isEmpty(this.state.data.detail.fileNo) && <div className="columns">
                                            <div className="column is-narrow" style={{ display: "flex", alignItems: "center" }}>
                                                <SvgRefresh className="refresh-icon" />
                                                <div style={{ justifyContent: "flex-start" }} className="link-internal"
                                                    onClick={() => this.updateRequest('cre')}
                                                >
                                                    <Translate id="RpveDetail.Button.Cre" />
                                                </div>
                                            </div>
                                        </div>}
                                        <div className="columns">
                                        <div className="column is-narrow" style={{ display: "flex", alignItems: "center" }}>
                                                <SvgRefresh className="refresh-icon" />
                                                <div style={{ justifyContent: "flex-start" }} className="link-internal" 
                                                onClick={() => this.updateRequest('rpve')}
                                                >
                                                    <Translate id="RpveDetail.Button.Rpve" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <CeeReportDateInformation inserted={this.state.data.header.insertedFormated}
                                        completed={this.state.data.header.completedFormated}
                                      
                                    />
                                </div>
                                <div className="search-results-manager" style={{ fontWeight: "bold", paddingBottom: "1em" }}>
                                    <div className='result-counts'>
                                        <span>
                                            <Translate id="Search.Cee.ResultCount" />:&nbsp;&nbsp;
                                            {this.state.data.detail.documents.length}
                                        </span>
                                    </div>
                                </div>
                                {this.state.data.detail.documents.length > 0 && <div>

                                    <OldStyleTableWithHistory offsetLeft={false} pageSize={this.props.pageSize} isLimited={false} classNames='related-addresses'
                                head={() => this.renderHead()} tableColumns={3} stripped
                                actualData={this.state.data.detail.documents} actualRow={(document) => this.renderRow(document, index++)}
                            />

                                </div>
                                }
                                <ExcelExportButton rpve={this.props.requestId} />
                            </div>
                        </div>
                        <div className="disclaimer-wrapper">
                            <div className="disclaimer-gray">
                                <Translate id={this.state.country === "SK" ? "Report.DisclaimerSk" : "Report.DisclaimerCz"} options={{ renderInnerHtml: true }} />
                            </div>
                        </div>
                    </>}
                </div>
            )
        
    
    }

    updateRequest = (registry) => {
        this.props.setResultsRequestParams('rpve', null);
        this.props.setRpveData(this.state.data, this.state.searchType, registry);
        this.setState({ requestedRegistry: registry });
    }

    renderHead = () => {
        return <thead>
            <tr>
                <th className="col-3"><Translate id="RpveDetail.Table.Obliged" /></th>
                <th className="col-3"><Translate id="RpveDetail.Table.Eligible" /></th>
                <th className="col-2" align="right"><Translate id="RpveDetail.Table.ECLI" /></th>
                <th className="col-4" align='right'><Translate id="RpveDetail.Table.Dates" /></th>

            </tr>
        </thead>
    }

    renderRow = (document, index) => {
        var subjectObligedO = document.subjects.filter(subj => subj.entitledObliged.includes("O"));
        var subjectObligedE = document.subjects.filter(subj => subj.entitledObliged.includes("E"));

        return <tr key={index}>
            <td >{subjectObligedO.map((o, i) => this.formatSubjectData(o, i))}</td>
            <td >{subjectObligedE.map((e, i) => this.formatSubjectData(e, i))}</td>
            <td align="right">{document.ecli}</td>
            <td align='right'>{document.issuedFormatted + " / " + document.dateOfPublicationFormatted}</td>
        </tr>
    }

    formatSubjectData = (subject, i) => {
        return <div style={{marginTop: i > 0 ? "1em" : "0"}}>
            <span><b>{this.isPO(subject.subjectType) ? subject.name : subject.firstname + " " + subject.surname }</b></span><br/>
            <span>{this.getAddressRow(subject)} </span><br/>
            {subject.birthDateSpecified && <><span> <Translate id="Report.NaturalIdentData.DateOfBirth" />:{`${subject.birthDateFormatted}`} </span><br/></>}
            {this.isPO(subject.subjectType) &&  <><span><Translate id="Report.CompanyIdentification.Ico" />:{`${subject.ico}`} </span><br/></> }
            <span>Typ osoby: {this.getSubjectType(subject.subjectType)}</span>
        </div>
    }

    getSubjectType = (subjectType) => this.isPO(subjectType) ?  <Translate id="Search.Common.Company"/> : <Translate id="Search.Common.PhysicalPerson"/>;

    isPO = (subjectType) => !subjectType.includes("FYZICKA_OSOBA");


    getAddressRow = (subject) => {
        return `${isNullOrUndefined(subject.street) ? '' : subject.street+','} ${subject.zip} ${subject.city}, ${subject.country}`;
    }


    getBaseUrl = (id) => `${window.babylonApiUrl}/api/search/rpve/requests/${id}`;


}
export default withLocalize(connect(
    state => state.registrySearch,
    dispatch => bindActionCreators({ ...registrySearchActions, ...popupActions }, dispatch)
)(RpveDetail));